module.exports = __webpack_public_path__ + "img/1580869424.08675353.jpg";